import {
  AirExchangeForTypeEnum,
  ExchangeActionEnum,
} from "@b2bportal/air-exchange-api";
import { ParentState, getCartInitialContext } from "@hopper-b2b/checkout";
import type {
  ISelectedTrip,
  SessionInfo,
  TripDetails,
} from "@hopper-b2b/types";
import { getInitialRewardsPaymentContext } from "@hsbc/rewards";
import { getInitialWalletPaymentContext } from "@hsbc/wallet";
import type { FlightExchangeMachineContext } from "./types";

/**
 * The values are populated in `flight-exchange-checkout/../FlightExchangeCheckout.tsx`
 *
 * If a new context is added, make sure to update CheckoutProvider's cleanContext to ensure
 * the new values are not reset
 */
export const getInitialFlightExchangeMachineContext =
  function (): FlightExchangeMachineContext {
    return {
      ...getCartInitialContext(),
      [ParentState.bookingConfirmation]: {},
      [ParentState.cardPayment]: {
        paymentMethods: [],
        selectedPaymentMethodId: undefined,
        spreedlyToken: undefined,
        error: undefined,
        visited: false,
        verifiedPaymentMethods: [],
      },
      [ParentState.contactInformation]: {
        contactInfo: {
          countryCode: "",
          email: "",
          phoneNumber: "",
        },
        visited: false,
      },
      [ParentState.passengerInformation]: {
        addPassport: false,
        currentInfantId: undefined,
        currentUserPassenger: undefined,
        error: undefined,
        infantOnlyError: false,
        isValidated: false,
        numPassengerAlertDismissed: false,
        selectedLapInfantIds: [],
        selectedPassengerIds: [],
        userPassengers: [],
        visited: false,
      },
      [ParentState.review]: {
        visited: false,
      },
      auth: {
        guestUser: {
          givenName: undefined,
          surname: undefined,
        },
      },
      awardsPayment: getInitialRewardsPaymentContext(),
      common: {
        tripPricing: undefined,
      },
      exchangeContext: {
        exchangePolicy: undefined,
        exchangeScenario: undefined,
        originalItinerary: undefined,
      },
      exchangeSearch: {
        exchangeFor: AirExchangeForTypeEnum.RoundTrip,
        outboundSelection: ExchangeActionEnum.Keep,
        returnSelection: undefined,
      },
      featureFlags: {
        enableHFv2: true,
      },
      flightSearch: {
        tripCategory: undefined,
        destination: null,
        origin: null,
        departureDate: null,
        returnDate: null,
        originCountryCode: "",
        destinationCountryCode: "",
        multicityRoutes: [],
      },
      flightShop: {
        tripDetails: {} as TripDetails,
        selectedTrip: {} as ISelectedTrip,
        shopPricingInfo: {
          fare: undefined,
        },
        departureLabel: "",
        returnLabel: undefined,
        airports: undefined,
        selectedMulticityTrips: [],
      },
      sessionInfo: {} as SessionInfo,
      walletPayment: getInitialWalletPaymentContext(),
    };
  };
